module.exports = __webpack_public_path__ + "static/covid-2a92981af920700f6c85fd369ed90c20.jpg";